import { render } from "./contact.vue?vue&type=template&id=6b4d3990&scoped=true&ts=true"
import script from "./contact.vue?vue&type=script&lang=ts"
export * from "./contact.vue?vue&type=script&lang=ts"

import "./contact.vue?vue&type=style&index=0&id=6b4d3990&lang=less&scoped=true"

import exportComponent from "E:\\dyy\\备份\\百廿官网\\bnkjgw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4d3990"]])

export default __exports__